<template lang="html">
  <div id="visualizar-beneficiario" dusk="visualizar-beneficiario">
    <div v-if="beneficiario" class="vx-row">
      <vs-col vs-lg="12" vs-md="12" vs-sm="12" class="vx-col mb-4">
        <vx-card ref="visualizarClienteDadosCard" class="h-full" title="Dados pessoais" cardBorder noShadow>
          <div class="vx-row">
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Cliente:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <p class="w-full" name="nome">{{ beneficiario.nome }}</p>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>CPF:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <p class="w-full" name="telefone">{{ beneficiario.cpf }}</p>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Data Nascimento:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <p class="w-full" name="email">{{ beneficiario.data_nascimento }}</p>
                </vs-col>
              </div>
            </vs-col>
          </div>
          <div class="vx-row">
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Nº do Documento:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <p
                    name="documento"
                  >{{ beneficiario.rg  }}</p>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Orgão expedidor:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <p
                    name="orgaoExpedidor"
                  >{{ beneficiario.orgao_expeditor }} / {{ beneficiario.orgao_expeditor_uf }}</p>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Nome da mãe:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <p
                    name="nome_mae"
                  >{{ beneficiario.nome_mae }}</p>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Nome do pai:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <p
                    name="nome_pai"
                  >{{ beneficiario.nome_pai }}</p>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Naturalização:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <p
                    name="naturalidade"
                  >{{ beneficiario.naturalidade }}</p>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Estado Civil:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <p
                    name="estadoCivil"
                  >{{ beneficiario.estadoCivil.nome }}</p>
                </vs-col>
              </div>
            </vs-col>
          </div>
        </vx-card>
      </vs-col>
    </div>
    <div v-if="beneficiario" class="vx-row">
      <vs-col vs-lg="12" vs-md="12" vs-sm="12" class="vx-col mb-4">
        <vx-card ref="visualizarClienteEnderecoCard" class="h-full" title="Endereço" cardBorder noShadow>
          <template v-for="enderecos in beneficiario.enderecos">
            <div class="vx-row" style="margin-top:20px">
              <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
                <div class="vx-row">
                  <vs-col vs-w="12" class="vx-col">
                    <span>CEP:</span>
                  </vs-col>
                  <vs-col vs-w="12" class="vx-col">
                    <p class="w-full" name="nome">{{ enderecos.cep }}</p>
                  </vs-col>
                </div>
              </vs-col>
              <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
                <div class="vx-row">
                  <vs-col vs-w="12" class="vx-col">
                    <span>Rua, nº:</span>
                  </vs-col>
                  <vs-col vs-w="12" class="vx-col">
                    <p class="w-full" name="endereco">{{ enderecos.endereco }}</p>
                  </vs-col>
                </div>
              </vs-col>
              <vs-col v-if="enderecos.complemento" vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
                <div class="vx-row">
                  <vs-col vs-w="12" class="vx-col">
                    <span>Complemento:</span>
                  </vs-col>
                  <vs-col vs-w="12" class="vx-col">
                    <p class="w-full" name="complemento">{{ enderecos.complemento }}</p>
                  </vs-col>
                </div>
              </vs-col>
              <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
                <div class="vx-row">
                  <vs-col vs-w="12" class="vx-col">
                    <span>Bairro:</span>
                  </vs-col>
                  <vs-col vs-w="12" class="vx-col">
                    <p class="w-full" name="bairro">{{ enderecos.bairro }}</p>
                  </vs-col>
                </div>
              </vs-col>
              <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
                <div class="vx-row">
                  <vs-col vs-w="12" class="vx-col">
                    <span>Estado:</span>
                  </vs-col>
                  <vs-col vs-w="12" class="vx-col">
                    <p class="w-full" name="estado">{{ enderecos.cidade.estado.nome }}</p>
                  </vs-col>
                </div>
              </vs-col>
              <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
                <div class="vx-row">
                  <vs-col vs-w="12" class="vx-col">
                    <span>Cidade:</span>
                  </vs-col>
                  <vs-col vs-w="12" class="vx-col">
                    <p class="w-full" name="cidade">{{ enderecos.cidade.nome }}</p>
                  </vs-col>
                </div>
              </vs-col>
            </div>
          </template>
        </vx-card>

      </vs-col>
    </div>
    <div v-if="beneficiario" class="vx-row">
      <vs-col vs-lg="12" vs-md="12" vs-sm="12" class="vx-col mb-4">
        <vx-card ref="visualizarClienteTelefoneCard" class="h-full" title="Telefone" cardBorder noShadow>
            <div class="vx-row" v-for="telefones in beneficiario.telefones">
              <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
                <div class="vx-row">
                  <vs-col vs-w="12" class="vx-col">
                    <span>Telefone:</span>
                  </vs-col>
                  <vs-col vs-w="12" class="vx-col">
                    <p class="w-full" name="nome">({{ telefones.ddd }}) {{ telefones.telefone }}</p>
                  </vs-col>
                </div>
              </vs-col>
            </div>
        </vx-card>
      </vs-col>
    </div>
    <div v-if="!beneficiario" class="fill-row-loading">
      <div :class="{'activeLoading':activeLoading}"  :id="[`loading-container`]" class="vs-con-loading__container loading-example">
      </div>
    </div>
  </div>
</template>

<script>
import { DownloadIcon } from "vue-feather-icons";
import {} from "@constants/index";
import api from "@services/api-service";
import queryParams from "@services/repository-service";

export default {
  name: "beneficiario-visualizar",
  data() {
    return {
      beneficiario: null,
      loading: false,
      activeLoading: false
    };
  },
  watch: {
    loading(loading) {
      if (!this.$refs.visualizarClienteDadosCard) return;

      const cards = [
        this.$refs.visualizarClienteDadosCard,
        this.$refs.visualizarClienteEnderecoCard,
        this.$refs.visualizarClienteTelefoneCard
      ];

      if (loading) {
        cards.map(card => card.refreshcard());
      } else {
        cards.map(card => card.removeRefreshAnimation());
      }
    }
  },
  methods: {
    getClient() {
      return new Promise((resolve, reject) => {
        api()
          .get(`clientes/${this.$route.params.id}`, {
            params: queryParams({
              relationships: ["estadoCivil", "enderecos", "telefones"]
            })
          })
          .then(response => {
            if (response.data.status) {
              this.loading = false;
              resolve(response);
            } else {
              this.loading = false;
            }
          })
          .catch(error => reject(error));
      });
    },
    async show() {
      const client = await this.getClient();
      this.beneficiario = client.data.data;
    }
  },
  mounted() {
    this.$vs.loading({
      container: `#loading-container`
    });
  },
  created() {
    this.loading = true;

    this.show();
  }
};
</script>
